import { FC } from "react";
import { Box } from "@mui/material";
import {
  RxBasicInfoDto,
  ExportDataItemDto,
} from "../../../../../../../api-client";
import { RxListPanel } from "./RxListPanel";
import { ExportListPanel } from "./ExportListPanel";

interface MiddlePanelProps {
  rxs: RxBasicInfoDto[];
  exportData: ExportDataItemDto[];
  onRxClick: (rx: RxBasicInfoDto) => void;
  onExportClick: (exportItem: ExportDataItemDto) => void;
  selectedItem:
    | { type: "rx"; data: RxBasicInfoDto }
    | { type: "export"; data: ExportDataItemDto }
    | null;
  transactionId: string;
  onClearSelection?: () => void;
}

export const MiddlePanel: FC<MiddlePanelProps> = ({
  rxs,
  exportData,
  onRxClick,
  onExportClick,
  selectedItem,
  transactionId,
  onClearSelection,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.75,
        height: "100%",
        minHeight: 0,
      }}
    >
      {/* Upper: Rx List */}
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <RxListPanel
          rxs={rxs}
          onRxClick={onRxClick}
          selectedRxId={
            selectedItem?.type === "rx" ? selectedItem.data.id : null
          }
          transactionId={transactionId}
          onClearSelection={onClearSelection}
        />
      </Box>

      {/* Lower: Export List */}
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <ExportListPanel
          exportData={exportData}
          onExportClick={onExportClick}
          selectedExportId={
            selectedItem?.type === "export" ? selectedItem.data.id : null
          }
        />
      </Box>
    </Box>
  );
};
